import { Route, Routes } from 'react-router-dom-v5-compat'
import { AccountsTransactionsMetadataProvider } from 'features/AccountsTransactions'

import { useRefreshAccounts } from 'hooks/banking'
import { ROOT } from 'const/routes'
import { Transfer } from 'pages/Transfer/Transfer'
import { AccountFilterValuesWrapper } from 'layouts/AccountLayout/AccountFilterValuesWrapper/AccountFilterValuesWrapper'
import { AccountLayout } from 'layouts/AccountLayout/AccountLayout'
import { AccountsLayout } from 'layouts/AccountsLayout/AccountsLayout'

import { TransfersLayout } from '../../../pages/Transfer/TransferLayout/TransferLayout'
import { Accounts } from '../Accounts/Accounts'
import { AccountsTransactions } from '../AccountsTransactions/AccountsTransactions'
import { AccountRoutes } from './AccountRoutes/AccountRoutes'
import { PrivateAccountsRoute } from './PrivateAccountsRoute/PrivateAccountsRoute'

export const AccountsRoutes = () => {
  useRefreshAccounts()

  return (
    <Routes>
      <Route element={<PrivateAccountsRoute />}>
        <Route
          element={
            <AccountsTransactionsMetadataProvider>
              <AccountFilterValuesWrapper>
                <AccountsLayout />
              </AccountFilterValuesWrapper>
            </AccountsTransactionsMetadataProvider>
          }
        >
          <Route index element={<Accounts />} />

          <Route
            path={ROOT.PORTAL.ACCOUNTS.TRANSACTIONS.relative}
            element={<AccountsTransactions />}
          />
        </Route>

        <Route element={<TransfersLayout />}>
          <Route
            path={ROOT.PORTAL.ACCOUNTS.TRANSFER.relative}
            element={<Transfer />}
          />
        </Route>

        <Route
          element={
            <AccountsTransactionsMetadataProvider>
              <AccountFilterValuesWrapper>
                <AccountLayout />
              </AccountFilterValuesWrapper>
            </AccountsTransactionsMetadataProvider>
          }
        >
          <Route
            path={`${ROOT.PORTAL.ACCOUNTS.ACCOUNT().relative}/*`}
            element={<AccountRoutes />}
          />
        </Route>
      </Route>
    </Routes>
  )
}
